import React from 'react';
import { FaUsers } from 'react-icons/fa';
import useCollaboration from '../../hooks/useCollaboration';
import { currentUserId } from '../../collaboration/store';
import './collaboration.css';

const initials = (name) =>
  (name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

/**
 * Muestra qué peritos tienen este peritaje abierto ahora mismo.
 *
 * El que aparece marcado es el usuario conectado: sirve de recordatorio de que
 * los cambios se comparten con los demás.
 */
export default function PresenceBar({ inspectionId }) {
  const collab = useCollaboration(inspectionId);
  const me = currentUserId();

  return (
    <div
      className="collab-presence"
      title={collab.connected ? 'Sincronizando en vivo' : 'Sin conexión en vivo'}
    >
      <span
        className={`collab-presence__dot ${collab.connected ? 'is-online' : 'is-offline'}`}
      />
      <FaUsers className="me-1" />
      <span className="me-2 d-none d-md-inline">
        {collab.connected ? 'Trabajando en vivo' : 'Trabajando sin sincronizar'}
      </span>

      {collab.presence.map((person) => (
        <span
          key={person.id}
          className={`collab-presence__avatar${person.id === me ? ' is-me' : ''}`}
          title={person.id === me ? `${person.name} (vos)` : person.name}
        >
          {initials(person.name)}
        </span>
      ))}
    </div>
  );
}